import { createFileRoute, redirect } from '@tanstack/react-router'
import { AnalysisTagsScreen } from '@/features/accounting-analysis-tags/analysis-tags-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/analysis-tags')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_settings.edit')) {
      throw redirect({ to: '/accounting' })
    }
  },
  component: AnalysisTagsScreen,
})
